import React from "react";
import Tool from "../../../../../Base/Tool";
import CustomSelect from "../../../../../Base/CustomSelect";
const languagesList = [
  {
    id: "1",
    value: "English",
    icon: "/images/flags/usa.png",
  },
  {
    id: "2",
    value: "French",
    icon: "/images/flags/usa.png",
  },
  {
    id: "3",
    value: "British",
    icon: "/images/flags/usa.png",
  },
];
const currencyList = [
  {
    id: "1",
    value: "US Dollar ($)",
    icon: "/images/flags/usa.png",
  },
  {
    id: "2",
    value: "TMT Manat ($)",
    icon: "/images/flags/usa.png",
  },
  {
    id: "3",
    value: "GB Pound ($)",
    icon: "/images/flags/usa.png",
  },
];
const theme = [
  {
    id: "1",
    value: "Dark",
  },
  {
    id: "2",
    value: "Light",
  },
];
export default function Preferences({ updateForm, form }) {
  const changeMedium = (key) => (item) => updateForm({ [key]: item.value });
  const languagesListIndex = React.useMemo(() => {
    if (form.language !== "") {
      return languagesList.findIndex((item) => item.value === form.language);
    }
    return null;
    // eslint-disable-next-line
  }, []);
  const currencyListIndex = React.useMemo(() => {
    if (form.currency !== "") {
      return currencyList.findIndex((item) => item.value === form.currency);
    }
    return null;
    // eslint-disable-next-line
  }, []);
  const themeList = React.useMemo(() => {
    if (form.theme !== "") {
      return theme.findIndex((item) => item.value === form.theme);
    }
    return null;
    // eslint-disable-next-line
  }, []);
  console.log(form);
  return (
    <div className="profile">
      <h5>
        <span></span> Preferences
      </h5>
      <div className="profile__links">
        <div className="input__outer">
          <label htmlFor="">
            Language
            <Tool text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverunt sed montes, quis." />
          </label>
          <CustomSelect
            list={languagesList}
            selected={languagesList[languagesListIndex]}
            onChange={changeMedium("language")}
          />
        </div>
        <div className="input__outer">
          <label htmlFor="">
            Theme
            <Tool text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverunt sed montes, quis." />
          </label>
          <CustomSelect
            list={theme}
            selected={theme[themeList]}
            onChange={changeMedium("theme")}
          />
        </div>
        <div className="input__outer">
          <label htmlFor="">
            Currency
            <Tool text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverunt sed montes, quis." />
          </label>
          <CustomSelect
            list={currencyList}
            selected={currencyList[currencyListIndex]}
            onChange={changeMedium("currency")}
          />
        </div>
      </div>
    </div>
  );
}
